<ng-container *ngIf="cart && !cart.isEmpty">
  <div class="cart-widget">
    <button type="button" class="cart-button" (click)="togglePanel()" aria-label="Open cart">
      <i class="fa fa-shopping-cart"></i>
      <span class="badge" *ngIf="itemCount > 0">{{ itemCount }}</span>
    </button>

    <div class="cart-backdrop" *ngIf="panelVisible" (click)="closePanel()"></div>
    <div class="cart-panel" *ngIf="panelVisible">
      <div class="cart-panel__header">
        <div>
          <h4>Cart</h4>
          <small>
            {{ itemCount }} Extra XCO{{ itemCount > 1 ? 's' : '' }} (ADDP{{ itemCount > 1 ? 's' : '' }})
            <span *ngIf="cartTotal">&nbsp;·&nbsp;{{ cartTotal }}</span>
          </small>
        </div>
        <button type="button" class="close-btn" (click)="closePanel()" aria-label="Close cart panel">
          <i class="fa fa-close"></i>
        </button>
      </div>

      <div class="cart-panel__body">
        <div *ngFor="let item of cartItems" class="cart-item">
          <div class="cart-item__icon">
            <i class="fa fa-random"></i>
          </div>
          <div class="cart-item__details">
            <div class="cart-item__title">{{ itemTitle(item) }}</div>
            <div class="cart-item__meta">
              Qty {{ getQuantity(item) }} · {{ formatLineTotal(item) }}
            </div>
          </div>
        </div>
      </div>

      <div class="cart-panel__footer">
        <button type="button" class="view-cart-btn" (click)="navigateToCart()">View Cart</button>
      </div>
    </div>
  </div>
</ng-container>
